var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { workspaceApi } from '../../../store/apimiddleware';
import { DataService } from '../../configure/service/deviceservice';
import { Constants } from '../../configure/models/constants';
import { sendAlertToServer } from '../floor/util';
const dataService = new DataService();
// Define a service using a base URL and expected endpoints
export const workspaceApiSlice = workspaceApi
    .enhanceEndpoints({
    addTagTypes: ['Workspaces'],
})
    .injectEndpoints({
    endpoints: (build) => ({
        register: build.mutation({
            query: (data) => ({
                url: 'register',
                method: 'post',
                data: data,
            }),
            onQueryStarted(token, { queryFulfilled }) {
                var _a;
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        yield queryFulfilled; // resolves on success
                    }
                    catch (err) {
                        const status = (_a = err === null || err === void 0 ? void 0 : err.error) === null || _a === void 0 ? void 0 : _a.status;
                        if (typeof status === 'undefined' ||
                            (typeof status === 'number' && status !== 409))
                            sendAlertToServer(Constants.ALERTS.REGISTER_API_FAIL, JSON.stringify({ err }));
                    }
                });
            },
        }),
        context: build.query({
            query: (data) => ({
                url: `context?token=${data}`,
                method: 'get',
            }),
            transformResponse: (response) => (Object.assign(Object.assign({}, response), { timeZoneId: response.timeZoneId === 'US/Pacific-New'
                    ? 'America/Los_Angeles'
                    : response.timeZoneId })),
            onQueryStarted(token, { queryFulfilled }) {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        yield queryFulfilled; // resolves on success
                    }
                    catch (err) {
                        sendAlertToServer(Constants.ALERTS.CONTEXT_API_FAIL, JSON.stringify({ err }));
                    }
                });
            },
        }),
        refresh: build.mutation({
            query: (data) => ({
                url: 'refresh',
                method: 'post',
                data: data,
            }),
        }),
        alerts: build.mutation({
            query: (data) => {
                const defaultData = {
                    domain: window.location.hostname,
                    error: 'Unknown',
                    errorType: Constants.ALERTS.UNKNOWN_ERROR.name,
                    severity: Constants.ALERTS.UNKNOWN_ERROR.severity,
                    meta: {
                        timeStamp: Math.floor(Date.now() / 1000),
                        tenant: dataService.getTenantId(),
                        token: dataService.getDeviceToken(),
                        userAgent: navigator.userAgent,
                    },
                };
                return {
                    url: `https://${window.location.hostname}/v1/console/log`,
                    method: 'post',
                    data: Object.assign(Object.assign({}, defaultData), data),
                    headers: {
                        'Workspaces-Device-Token': dataService.getDeviceToken(),
                        'User-Agent': navigator.userAgent,
                    },
                };
            },
        }),
    }),
});
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useRegisterMutation, useContextQuery, useRefreshMutation, useAlertsMutation, } = workspaceApiSlice;
